import Axios from '@/Axios'

class ShifTypeService {
    async createShiftType(data) {
        return await Axios.post('wms.wms.api.shift_type.create_shift_type', data)
    }

    async getShiftTypes(data) {
        return await Axios.get('wms.wms.api.shift_type.get_shift_types', { params: data })
    }

    async updateShiftTpe(data) {
        return await Axios.put(`wms.wms.api.shift_type.update_shift_type`, data)
    }
    async getShiftType(shiftId) {
        return await Axios.get('wms.wms.api.shift_type.get_shift_type_by_id', { params: { shift_name: shiftId } })
    }
    async deleteShiftType(shift_type) {
        const transformedSection = shift_type.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.shift_type.delete_shift_types', { data: { shift_name: transformedSection } })
    }
}
export default new ShifTypeService()
